import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi } from "@/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const check = useCallback(async () => {
    const token = localStorage.getItem("spm_token");
    if (!token) {
      setUser(null);
      return;
    }
    try {
      const { data } = await adminApi.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("spm_token");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("spm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("spm_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout, check }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
